import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { isPublicRequest } from 'app/core/auth/public-requests';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const authRefreshInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    // Public requests never need a token, so don't let a stale session
    // (e.g. a dead refresh token) block an anonymous application.
    if (
        !req.url.includes('/api/users/refresh') &&
        !isPublicRequest(req.url) &&
        authService.accessToken &&
        AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        return authService.refreshAccessToken().pipe(
            switchMap((_) => {
                return next(req);
            })
        );
    }

    return next(req);
};
